<template>
  <div class="flex items-stretch border border-light-gray rounded" :class="{ 'flex-col': vertical }">
    <div class="icon" @click="toggle">
      <LockClosed v-if="internalLocked" />
      <LockOpen v-else />
    </div>
    <div class="border-l border-l-light-gray grow p-4" :class="{ 'bg-table-head-gray': internalLocked }">
      <!--      <component-->
      <!--        :is="is"-->
      <!--        v-if="locked"-->
      <!--        :model-value="defaultValue"-->
      <!--        v-bind="$attrs"-->
      <!--        :label="`${label} - (DEFAULT)`"-->
      <!--        disabled-->
      <!--      />-->
      <!--      <component-->
      <!--        :is="is"-->
      <!--        v-else-->
      <!--        v-model="internalModelValue"-->
      <!--        v-bind="$attrs"-->
      <!--        :label="label"-->
      <!--      />-->
      <slot v-if="internalLocked" name="default" />
      <slot v-else name="modelValue" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import LockClosed from '@images/lock_closed.svg?component';
import LockOpen from '@images/lock_open.svg?component';
import { useVModel } from '@vueuse/core';

interface Props {
  modelValue: boolean;
  vertical?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:modelValue']);
const internalLocked = useVModel(props, 'modelValue', emit);

const toggle = () => {
  internalLocked.value = !internalLocked.value;
};
</script>

<style lang="scss" scoped>
.icon {
  @apply p-4;
  @apply flex items-center justify-center;
  cursor: pointer;
  user-select: none;
}
.icon > * {
  height: 2rem;
  width: 2rem;
}
</style>
